import { render, staticRenderFns } from "./dictInfo.vue?vue&type=template&id=2d46db12&scoped=true"
import script from "./dictInfo.vue?vue&type=script&lang=js"
export * from "./dictInfo.vue?vue&type=script&lang=js"
import style0 from "./dictInfo.vue?vue&type=style&index=0&id=2d46db12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d46db12",
  null
  
)

export default component.exports